module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_04_american-village-4327b0bf7e46b9e31cbf7d0c5b20fadc.jpg";